import {Time} from "./Utils/Unity/Time";
import {GameManager} from "./Game/GameManager";
import {Core} from "./Base/Core";
import {di} from "@dp-instant/core";
import {TypesAds} from "@dp-instant/interfaces";
import {decorate, injectable} from "inversify";

const AD_PLACEMENT_INTERSTITIAL = "427004178938893_487160786256565";
const AD_PLACEMENT_BANNER = "427004178938893_487160706256573";
const AD_PLACEMENT_REWARDED = "427004178938893_487160856256558";

export class AdsProviderCommon {
    static initialized = false;
    static showing = false;

    static lastRewardedVideoTime = -100;
    static lastInterstitialTime = -100;

    static interstitialTimeout = 120;

    static rewardedAd = null;
    static rewardedAdReady = true; //set to true for not fb
    static rewardedAdRetry = 0;
    static interstitialAd = null;
    static interstitialAdReady = true; //set to true for not fb
    static interstitialAdRetry = 0;

    static get nextInterstitialTime() {
        return this.lastInterstitialTime + ~~this.interstitialTimeout;
    }

    static get nextInterstitialDelay() {
        return this.nextInterstitialTime - Time.time;
    }

    static get interstitialPaused() {
        return this.nextInterstitialDelay > 0;
    }

    static get nextRewardedTimeout() {
        if (!Core.GameData.Config.timeoutBetweenRewardedAds) return 0;
        let delta = Time.time - this.lastRewardedVideoTime;
        return Math.max(0, Core.GameData.Config.timeoutBetweenRewardedAds - delta);
    }

    static async showRewardedAd() {
        let result = false;
        try {
            const adManager = di.get(TypesAds.manager);
            this.showing = true;
            Core.SetPause(true);
            console.log("show rewarded");
            result = await adManager.showRewardAd(AD_PLACEMENT_REWARDED);
            this.lastRewardedVideoTime = Time.time;
        } catch (e) {
            console.log("ADS: Rewarded error", e);
        }
        Core.SetPause(false);
        this.showing = false;
        this.rewardedAd = null;
        this.rewardedAdReady = true; // set to true for not fb
        console.log(result);
        return result;
    }

    static async showInterstitialAd() {
        let result = false;
        try {
            //
            const adManager = di.get(TypesAds.manager);
            this.showing = true;
            Core.SetPause(true);
            console.log("show interstitial");
            result = await adManager.showAd(AD_PLACEMENT_INTERSTITIAL);
            this.lastInterstitialTime = Time.time;
        } catch (e) {
            console.log("ADS: Interstitial error", e);
        }
        Core.SetPause(false);
        this.showing = false;
        this.interstitialAd = null;
        this.interstitialAdReady = true; // set to true for not fb
        console.log(result);
        return result;
    }

    static setInterstitialTimeout(val) {
        this.interstitialTimeout = Math.max(this.interstitialTimeout, ~~val);
    }

    static Init() {
        if (this.initialized) return;
        this.interstitialTimeout = Core.GameData.Config.startTimeout;
        this.onEpochSelected = this.onEpochSelected.bind(this);
        GameManager.on("EpochSelected", this.onEpochSelected);
        this.initialized = true;
    }

    static onEpochSelected(epochId) {
        if (Time.time > 15) this.TriggerInterstitial();
    }

    static async TriggerInterstitial() {
        console.log("TriggerInterstitial");
        if (this.interstitialPaused) {
            console.log("ADS: paused for", this.nextInterstitialDelay);
            return;
        }

        if (
            !Core.GameData.Config.interstitialAdsCollectionSize ||
            Core.Player.PlanetsSave.collection.length <
                Core.GameData.Config.interstitialAdsCollectionSize
        ) {
            console.log("ADS: too early! Small collection.");
            return;
        }

        if (Core.Player.NoAds || Core.Store.VipActive) {
            console.log("ADS: VIP, periodic ads off");
            return;
        }

        console.log("ADS: Periodic ads triggered");
        let shown = await this.showInterstitialAd();
        this.resetInterstitialTimeout();
        if (shown) {
            Core.WaitBefore(0.1, () => {
                Core.UI.interstitialRewardRandom.Show();
            });
        }
    }

    static resetInterstitialTimeout() {
        let timeout = Core.GameData.Config.defaultTimeout;

        // get last creature id
        let lastCreatureId =
            Core.Player.PlanetsSave.collection.length > 0
                ? Core.Player.PlanetsSave.collection[Core.Player.PlanetsSave.collection.length - 1]
                : 1;
        // get creature data
        let creatureData = Core.GameData.Creatures.Get(lastCreatureId);
        if (creatureData) {
            timeout = ~~Core.GameData.Config.GetTimeoutByCreature(creatureData.creatureRank);
        }

        this.interstitialTimeout = timeout;
    }

    static async TriggerRewarded(callback) {
        console.log("TriggerRewarded");
        if (this.nextRewardedTimeout > 0) return;
        let result = await this.showRewardedAd();
        this.lastRewardedVideoTime = Time.time;
        if (result && callback) {
            callback();
        }
    }
}

decorate(injectable(), AdsProviderCommon);
